// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--28kDM","body":"body--2Ru49"};